import { render, staticRenderFns } from "./IconCameraBig.vue?vue&type=template&id=4a1c5bf7&"
import script from "./IconCameraBig.vue?vue&type=script&lang=js&"
export * from "./IconCameraBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports